const parseDate = (date: string) => new Date(date.replace(/-/g, '/'));
export default parseDate;
